import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const toggleLanguage = () => {
    const newLang = currentLang === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
    >
      <i className="ri-global-line text-gray-600"></i>
      <span className="text-sm font-medium text-gray-700">
        {currentLang === 'ko' ? '한국어' : 'English'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;